'use client';

import { Card } from '../ui/Card';
import { Moon, Users, Shield } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';

const ICONS: LucideIcon[] = [Moon, Users, Shield];

export function UseCases() {
  const t = useTranslations('useCases');

  const items = t.raw('items') as Array<{
    title: string;
    description: string;
  }>;

  return (
    <section className="py-20 px-4 bg-section-of-white">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-4 text-navy">
          {t('title')}
        </h2>
        <p className="text-lg md:text-xl text-center text-foreground max-w-3xl mx-auto mb-16">
          {t('subtitle')}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {items.map((item, index) => {
            const Icon = ICONS[index] ?? Shield;
            return (
              <Card key={index} hover className="relative">
                <Icon className="w-8 h-8 text-accent mb-4" aria-hidden />
                <h3 className="text-xl font-semibold text-foreground mb-3">{item.title}</h3>
                <p className="text-foreground leading-relaxed">{item.description}</p>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
}
